import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-collapsible" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }

import CollapseControllerSummaryNew from './CollapseControllerSummaryNew.vue'
import { useI18n } from 'vue-i18n'
import AccordionText from '@/design-system/atoms/AccordionText.vue'
import DropdownCalendar from '@/design-system/molecules/DropdownCalendar.vue'
import { useFeature } from '@/pinia/features'
import { computed } from 'vue'
import { DateSelection } from '@/interfaces/dateselection.interface'
import { DateTimeRange } from '@/composables/useTimeRange'
import { LocaleString } from '@/components/types'

type Props = {
  isCollapsed: boolean
  showCalendar: boolean
  defaultSelection: string
}
type Emits = {
  (e: 'toggle-collapse')
  (e: 'present-calendar')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CollapseControllerNew',
  props: {
    isCollapsed: { type: Boolean },
    showCalendar: { type: Boolean },
    defaultSelection: {}
  },
  emits: ["toggle-collapse", "present-calendar"],
  setup(__props: any) {

const { t } = useI18n()
const { feature } = useFeature('home/*/*/*/time')


const label = t('general__text__dashboard_change_filtering')

const dateSelections = computed(() =>
  feature.value?.children?.map(
    (child): DateSelection => ({
      name: child.name,
      title: child.title,
      access: child.access as string[],
      range: child.props.range as DateTimeRange,
      icon: child.props.icon as LocaleString
    })
  )
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CollapseControllerSummaryNew, {
        showTimeSelection: false,
        fullscreen: false
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (dateSelections.value)
        ? (_openBlock(), _createBlock(DropdownCalendar, {
            key: 0,
            id: "calendar-open-button",
            dateSelection: dateSelections.value,
            defaultSelection: _ctx.defaultSelection,
            onPresentCalendar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('present-calendar')))
          }, null, 8, ["dateSelection", "defaultSelection"]))
        : _createCommentVNode("", true),
      _createVNode(AccordionText, {
        id: "collapse-toggle-button",
        active: !_ctx.isCollapsed,
        size: 'small',
        accordionText: _unref(label),
        onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-collapse')))
      }, null, 8, ["active", "accordionText"])
    ])
  ]))
}
}

})